import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const AdditionalServices = ({
  additionalServicesList,
  contentfulError,
  viewType,
  additionalServices,
  setAdditionalServices,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { additionalServicesHeading }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching additional services data from contentful
        </Notification>
      )}

      {!contentfulError && additionalServicesList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{additionalServicesHeading}</Typography></SectionHeading>
            <Table
              viewType={viewType}
              additionalServices={additionalServices}
              setAdditionalServices={setAdditionalServices}
              list={additionalServicesList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

AdditionalServices.propTypes = {
  additionalServicesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  viewType: PropTypes.string.isRequired,
  additionalServices: PropTypes.shape({}).isRequired,
  setAdditionalServices: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default AdditionalServices;
